/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path, G } from 'react-native-svg';

import { IconProps } from '../lib';

function Baseball(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128}
        cy={128}
        r={96}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M181.19142,79.40281a96.385,96.385,0,0,1,14.80852-19.167"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M196,195.76425a96.38487,96.38487,0,0,1-14.80811-19.16636"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M168.74273,140a97.31136,97.31136,0,0,1,0-24"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <G>
        <Path
          d="M74.80858,79.40281a96.385,96.385,0,0,0-14.80852-19.167"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <Path
          d="M60.00005,195.76425a96.38487,96.38487,0,0,0,14.80811-19.16636"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <Path
          d="M87.25728,140A96.9478,96.9478,0,0,0,88,128a96.94587,96.94587,0,0,0-.74152-11.9903"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
      </G>
    </Svg>
  );
}

export default Baseball;
